export const sliceKey = 'configuratorsListing';
